import React from 'react';
import { BannerAction } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import { showModal, closeModal } from '../../../Utils';
import { dispatchOverlayLoad } from '../../shared/Analytics';
import { INVITE_PARTNER_MODAL } from '../../../Constants';

const invitePartnerClick = () => {
    showModal(INVITE_PARTNER_MODAL);
    dispatchOverlayLoad('Invite Partner Modal');
    closeModal('banner-invite-partner-modal');
};

const cancelClick = () => {
    closeModal('banner-invite-partner-modal');
};

const BannerInvitePartnerModal = ({ isCustomerWebView }) => {
    return (
        <BannerAction
            id={'banner-invite-partner'}
            title={'Invite a co-client'}
            text={'Sharing goals with a partner? Get a financial plan that\'s designed to reflect your overall situation.'}
            leftButtonText={'Cancel'}
            rightButtonText={'Invite Partner'}
            loadingTitle={'Inviting partner...'}
            loadingText={'One moment while we invite your partner...'}
            createClick={invitePartnerClick}
            cancelClick={cancelClick}
            isCustomerWebView={isCustomerWebView}
        />
    )
};

export default BannerInvitePartnerModal;